import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { showError } from '../../utils/Utils';

export const deleteGreyOrder = async (id) => {
    try {
        const deleteResp = await authAxiosInstance.delete(
            `greyPurchaseOrder/${id}`
        );
        toast.success('PO deleted');
        return deleteResp.data;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};

export const disconnectGreyOrder = async (id) => {
    try {
        const disconnectResp = await authAxiosInstance.patch(
            `greyPurchaseOrder/disconnect/${id}`
        );
        toast.success('PO disconnected');
        return disconnectResp.data;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};
